
/**
 * Cosmos website — smooth scroll, nav highlight, mobile menu
 */ function $2b6e161c9edcf319$var$initMobileNav() {
    const nav = document.querySelector('.nav');
    const toggle = document.getElementById('nav-toggle');
    const menu = document.getElementById('nav-menu');
    if (!nav || !toggle || !menu) return;
    function openMenu() {
        nav.classList.add('nav--open');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Close menu');
        document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
        nav.classList.remove('nav--open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        document.body.style.overflow = '';
    }
    toggle.addEventListener('click', ()=>{
        if (nav.classList.contains('nav--open')) closeMenu();
        else openMenu();
    });
    menu.querySelectorAll('a').forEach((link)=>{
        link.addEventListener('click', ()=>{
            if (window.matchMedia('(max-width: 768px)').matches) closeMenu();
        });
    });
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && nav.classList.contains('nav--open')) closeMenu();
    });
    window.addEventListener('resize', ()=>{
        if (window.innerWidth > 768 && nav.classList.contains('nav--open')) closeMenu();
    });
}
function $2b6e161c9edcf319$var$initNav() {
    const navLinks = document.querySelectorAll('.nav__links a');
    function setActiveLink() {
        const sections = Array.from(document.querySelectorAll('section[id]'));
        const scrollY = window.scrollY + 80;
        for(let i = sections.length - 1; i >= 0; i--){
            const section = sections[i];
            const top = section.offsetTop;
            const height = section.offsetHeight;
            if (scrollY >= top && scrollY < top + height) {
                navLinks.forEach(function(link) {
                    link.classList.remove('is-active');
                    const href = link.getAttribute('href');
                    if (href && href === '#' + section.id) link.classList.add('is-active');
                });
                return;
            }
        }
    }
    function smoothScrollTo(href) {
        const target = document.querySelector(href);
        if (target) target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
    navLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            if (link.classList.contains('nav__link--modal')) {
                e.preventDefault();
                return;
            }
            const href = this.getAttribute('href');
            if (href.startsWith('#')) {
                e.preventDefault();
                smoothScrollTo(href);
            }
        });
    });
    document.querySelectorAll('a[href^="#"]').forEach(function(a) {
        if (a.closest('.nav__links')) return;
        a.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href && href !== '#' && href.length > 1) {
                e.preventDefault();
                smoothScrollTo(href);
            }
        });
    });
    window.addEventListener('scroll', setActiveLink);
    setActiveLink();
}
const $2b6e161c9edcf319$var$FEEDBACK_MS = 2000;
function $2b6e161c9edcf319$var$initCodeBlockSparkles() {
    const SPARKLE_COUNT = 8;
    document.querySelectorAll('.code-block:not(.code-block--inline)').forEach((block)=>{
        const sparkles = document.createElement('div');
        sparkles.className = 'code-block__sparkles';
        sparkles.setAttribute('aria-hidden', 'true');
        for(let i = 0; i < SPARKLE_COUNT; i++){
            const s = document.createElement('span');
            s.className = 'code-block__sparkle';
            sparkles.appendChild(s);
        }
        block.prepend(sparkles);
    });
}
function $2b6e161c9edcf319$var$initCopyButtons() {
    document.querySelectorAll('.code-block').forEach((block)=>{
        const code = block.querySelector('code');
        const btn = block.querySelector('.code-block__copy');
        if (!code || !btn) return;
        const label = btn.querySelector('.code-block__copy-text');
        const done = btn.querySelector('.code-block__copy-done');
        if (!label || !done) return;
        let feedbackTimer = null;
        btn.addEventListener('click', async ()=>{
            const text = code.textContent?.trim() ?? '';
            if (!text) return;
            try {
                await navigator.clipboard.writeText(text);
            } catch  {
                return;
            }
            if (feedbackTimer) clearTimeout(feedbackTimer);
            label.hidden = true;
            done.hidden = false;
            btn.setAttribute('aria-label', done.textContent ?? '');
            feedbackTimer = setTimeout(()=>{
                feedbackTimer = null;
                label.hidden = false;
                done.hidden = true;
                btn.setAttribute('aria-label', label.textContent ?? '');
            }, $2b6e161c9edcf319$var$FEEDBACK_MS);
        });
    });
}
function $2b6e161c9edcf319$var$initAboutModal() {
    const openBtn = document.getElementById('open-about-modal');
    const dialog = document.getElementById('about-modal');
    if (!openBtn || !dialog) return;
    openBtn.addEventListener('click', (e)=>{
        e.preventDefault();
        dialog.showModal();
    });
    function closeModal() {
        dialog.close();
    }
    document.querySelectorAll('[data-close-modal]').forEach((el)=>{
        el.addEventListener('click', closeModal);
    });
    dialog.addEventListener('click', (e)=>{
        if (e.target === dialog) closeModal();
    });
    dialog.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape') closeModal();
    });
}
$2b6e161c9edcf319$var$initMobileNav();
$2b6e161c9edcf319$var$initNav();
$2b6e161c9edcf319$var$initAboutModal();
$2b6e161c9edcf319$var$initCodeBlockSparkles();
$2b6e161c9edcf319$var$initCopyButtons();


//# sourceMappingURL=repo.5a4fa21c.js.map
